import { useQuery } from '@tanstack/react-query';
import {
  DEFAULT_TERMINOLOGY,
  SettingsApi,
  Terminology,
} from '@/services/school.api';
import { useAuthStore } from '@/stores/auth.store';

/**
 * School-configurable academic labels (Class/Grade/Semester · Section/Batch).
 * Cached app-wide; falls back to defaults while loading or on error.
 */
export function useTerminology(): Terminology {
  // Org admin acting as a school may be looking at an unprovisioned legacy
  // school with no tenant schema/tables — never query it, use defaults.
  const orgToken = useAuthStore((s) => s.orgToken);
  const scope = useAuthStore((s) => s.user?.scope);
  const isOrgActingSession = !!orgToken && scope === 'school';

  const { data } = useQuery({
    queryKey: ['terminology'],
    queryFn: SettingsApi.getTerminology,
    staleTime: 5 * 60 * 1000,
    placeholderData: DEFAULT_TERMINOLOGY,
    enabled: !isOrgActingSession,
  });
  return data ?? DEFAULT_TERMINOLOGY;
}
